import Row from './StyledRow'

export default Row.extend`
  display: -ms-flexbox;
  border: 0;
  min-height: 39px;
  position: relative;
`
